import { getENV } from '../../utils/env';
import { getAuth0ClientId } from '../../utils/getAuth0ClientId';
import { getAuth0RedirectOrigin } from '../../utils/getAuth0RedirectOrigin';
import { AUTH0_CALLBACK_PATH } from './pendingAuth0ReturnTo';

export const AUTH0_SCOPE = 'openid profile email offline_access';

/**
 * Options shared by the app `Auth0Provider` and the cold-start silent probe.
 *
 * Both must use the same client, audience, scope, and `localstorage` cache so a
 * token written by the probe is readable by the provider. Iframe fallback is not
 * included: it is a client-wide setting, and the SDK uses it after both a missing
 * refresh token and `invalid_grant`. The probe enables it only after
 * `missing_refresh_token` so a revoked refresh token can still reach session logout.
 */
export function getAuth0SpaClientOptions() {
    const { NEXT_PUBLIC_AUTH0_AUDIENCE: audience, NEXT_PUBLIC_AUTH0_DOMAIN: domain } = getENV();

    return {
        domain,
        clientId: getAuth0ClientId(),
        authorizationParams: {
            audience,
            redirect_uri: `${getAuth0RedirectOrigin()}${AUTH0_CALLBACK_PATH}`,
            scope: AUTH0_SCOPE,
        },
        cacheLocation: 'localstorage' as const,
        useRefreshTokens: true as const,
    };
}
